import React, { useState, useEffect, useRef } from "react";
import {
  Badge,
  Breadcrumb,
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Row,
  Stack,
  Tab,
  Tabs,
} from "react-bootstrap";
import Confirm from "../Confirm";
import { Link, useLocation, useNavigate } from "react-router-dom";
import FilesCreate from "../file/FilesCreate";
import RelatedListFiles from "../file/RelatedListFiles";
import fuziElevatorsApi from "../../api/fuziElevatorsApi";
import Permissionhelper from "../common/Permissionhelper";
import * as constants from "../../constants/CONSTANT";
import PubSub from "pubsub-js";
import Chat from "../common/Chat";
import jwt_decode from "jwt-decode";
import { ROUTES } from "../../constants/webRouting";
import {
  formatDate,
  formatDateForCreatedDate,
  formatDateForView,
  getUserDetails,
} from "../../utils/helper";
import RelatedListTask from "../task/RelatedListTask";
import RelatedListHandover from "../handover/RelatedListHandover";
import TaskEdit from "../task/TaskEdit";
import HandoverEdit from "../handover/HandoverEdit";
import { RelatedListOrderAmc } from "../orderAmc";
import { PaymentEdit, PaymentRelatedList } from "../order";
import { RelatedListWarranty } from "../warranty";
import PERMISSIONS from "../../constants/permissions";

const OrderView = () => {
  const userInfo = getUserDetails();
  const location = useLocation();
  const navigate = useNavigate();
  // console.log('state',location.state);
  const [order, setOrder] = useState(location.state ? location.state : {});
  // console.log('order', order);
  const [payments, setPayments] = useState({}); // For Payments Tracking Use.
  const [modalShow, setModalShow] = useState(false);
  const [modalShowFile, setModalShowFile] = useState(false);
  const [modalShowTask, setModalShowTask] = useState(false);
  const [modalShowHandover, setModalShowHandover] = useState(false);
  const [modalShowPayment, setModalShowPayment] = useState(false);

  const [refreshFileList, setRefreshFileList] = useState(false);
  const [refreshTaskList, setRefreshTaskList] = useState();
  const [refreshHandoverList, setRefreshHandoverList] = useState(false);
  const [refreshWarrantyList, setRefreshWarrantyList] = useState(false);
  const [refreshOrderAmcList, setRefreshOrderAmcList] = useState(false);
  const [refreshPaymentList, setRefreshPaymentList] = useState();

  const [relatedListFiles, setRelatedListFiles] = useState(true);
  const [relatedListTaskList, setRelatedListTask] = useState(false);
  const [relatedListHandover, setRelatedListHandover] = useState(false);
  const [relatedListWarranty, setRelatedListWarranty] = useState(false);
  const [relatedListOrderAmc, setRelatedListOrderAmc] = useState(false);
  const [relatedListPayment, setRelatedListPayment] = useState(false);

  const [showDetails, setShowDetails] = useState(true);
  const [showNotesMessages, setShowNotesMessages] = useState(false);

  const [editDisable, setDisableEdit] = useState(true);

  const [paymentsTab, setpaymentsTab] = useState(false);
  const [receivedPayment, setReceivedPayment] = useState(0);
  //Added Imran Khan on 18 feb 2026
  const [warrantyExists, setWarrantyExists] = useState(false);
  const [creatingWarranty, setCreatingWarranty] = useState(false);
  useEffect(() => {
    // let userInfoJWT = jwt_decode(localStorage.getItem("token"));
    // setUserInfo(userInfoJWT);
    fetchOffer();
    // userInfoJWT.id === order.owner_id && setDisableEdit(false);
  }, []);

  const fetchOffer = () => {
    if (
      !order.id &&
      location.hasOwnProperty("pathname") &&
      location.pathname.split("/").length >= 3
    ) {
      order.id = location.pathname.split("/")[2];
    }
    async function init() {
      let result = await fuziElevatorsApi.fetchOrderById(order.id);
      const fetchPayment = await fuziElevatorsApi.fetchOrderWisePayments(
        order.id,
      ); //Using to Fetch Payments Record Wise By id

      if (result) {
        setOrder(result);
      } else {
        setOrder({});
      }
      if (fetchPayment) {
        setPayments(fetchPayment);
      } else {
        setPayments({});
      }
    }
    init();
  };

  const deleteOrder = async () => {
    const result = await fuziElevatorsApi.deleteOrderById(order.id);

    if (result?.success) {
      PubSub.publish("RECORD_SAVED_TOAST", {
        title: "Deleted",
        message: "Record Deleted successfully",
      });
    } else {
      PubSub.publish("RECORD_ERROR_TOAST", {
        title: "Record update Error",
        message: result?.errors,
      });
    }
    navigate(ROUTES.ORDER.LIST);
  };

  const edit = () => {
    navigate(`${ROUTES.ORDER.LIST}/${order.id}/e`, { state: order });
  };

  const handleRelatedListTab = (key) => {
    if (key === "files") {
      setRelatedListFiles(true);
      setRelatedListTask(false);
      setRelatedListHandover(false);
      setRelatedListWarranty(false);
      setRelatedListOrderAmc(false);
      setRelatedListPayment(false);
    } else if (key === "tasks") {
      setRelatedListFiles(false);
      setRelatedListTask(true);
      setRelatedListHandover(false);
      setRelatedListWarranty(false);
      setRelatedListOrderAmc(false);
      setRelatedListPayment(false);
    } else if (key === "handover") {
      setRelatedListFiles(false);
      setRelatedListTask(false);
      setRelatedListHandover(true);
      setRelatedListWarranty(false);
      setRelatedListOrderAmc(false);
      setRelatedListPayment(false);
    } else if (key === "warranty") {
      setRelatedListFiles(false);
      setRelatedListTask(false);
      setRelatedListHandover(false);
      setRelatedListWarranty(true);
      setRelatedListOrderAmc(false);
      setRelatedListPayment(false);
    } else if (key === "orderAMCs") {
      setRelatedListFiles(false);
      setRelatedListTask(false);
      setRelatedListHandover(false);
      setRelatedListWarranty(false);
      setRelatedListOrderAmc(true);
      setRelatedListPayment(false);
    } else if (key === "payment") {
      setRelatedListPayment(true);
      setRelatedListFiles(false);
      setRelatedListTask(false);
      setRelatedListWarranty(false);
      setRelatedListHandover(false);
      setRelatedListOrderAmc(false);
    }
  };

  // Imran Khan Added condition for Payment Tab to hide from Installation Supervisor 24-Feb-2026
  const isInstallationSupervisor = userInfo?.userrole === "Installation Supervisor";

  const handleTab = (key) => {
    if (key === "details") {
      setShowDetails(true);
      setShowNotesMessages(false);
    } else if (key === "notesMessages") {
      setShowDetails(false);
      setShowNotesMessages(true);
    }
  };

  const submitFiles = () => {
    setModalShowFile(false);
    setRefreshFileList(Date.now());
    fetchOffer();
  };

  const submitTasks = () => {
    setModalShowTask(false);
    setRefreshTaskList((prev) => !prev);
  };

  const submitHandover = () => {
    setModalShowHandover(false);
    setRefreshHandoverList((prev) => !prev);
  };

  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [address, setAddress] = useState(`${order.site_address}`); // Default address

  useEffect(() => {
    const loadGoogleMapsScript = () => {
      if (!window.google) {
        const googleMapScript = document.createElement("script");
        googleMapScript.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyDtztwOW6bufAlbBWfO1k5FdZTkpUP_gmI&callback=initMap`;
        googleMapScript.async = true;
        googleMapScript.defer = true;
        googleMapScript && window.document.body.appendChild(googleMapScript);
      } else {
        window.initMap();
      }
    };

    window.initMap = () => {
      myMapFunction();
    };

    loadGoogleMapsScript();
  }, [latitude, longitude, address]);
  
  useEffect(() => {
    let isMounted = true;

    const checkWarranty = async () => {
      try {
        if (!order?.id) return;

        const check = await fuziElevatorsApi.checkWarrantyExists(order.id);

        if (isMounted) {
          setWarrantyExists(check?.exists === true);
        }
      } catch (error) {
        if (isMounted) {
          setWarrantyExists(false);
        }
      }
    };

    checkWarranty();

    return () => {
      isMounted = false;
    };
  }, [order?.id]);

  const myMapFunction = async () => {
    if (!latitude || !longitude) {
      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({ address: address }, (results, status) => {
        if (status === "OK") {
          const location = results[0].geometry.location;
          setLatitude(location.lat());
          setLongitude(location.lng());

          const mapProp = {
            center: location,
            zoom: 14,
          };

          const map = new window.google.maps.Map(
            document.getElementById("googleMapaddress"),
            mapProp,
          );

          const marker = new window.google.maps.Marker({
            map,
            position: location,
            title: results[0].formatted_address,
          });

          const infowindow = new window.google.maps.InfoWindow({
            content: results[0].formatted_address,
          });

          marker.addListener("click", () => {
            infowindow.open(map, marker);
          });

          setAddress(results[0].formatted_address);
        } else {
          console.error(
            "Geocode was not successful for the following reason: " + status,
          );
        }
      });
    } else {
      const location = new window.google.maps.LatLng(latitude, longitude);
      const mapProp = {
        center: location,
        zoom: 14,
      };

      const map = new window.google.maps.Map(
        document.getElementById("googleMapaddress"),
        mapProp,
      );

      const marker = new window.google.maps.Marker({
        map,
        position: location,
        title: address,
      });

      const infowindow = new window.google.maps.InfoWindow({
        content: address,
      });

      marker.addListener("click", () => {
        infowindow.open(map, marker);
      });
    }
  };

  //Payment Block Added By Farhan Khan
  const submitpayments = () => {
    setModalShowPayment(false);
    setRefreshPaymentList(Date.now());
    // setModalShowTask(false);
    fetchOffer(); //Added by Farhan to Refresh Data.
  };

  const onPaymentListUpdate = (total) => {
    setReceivedPayment(total);
  };

  const formatAmount = (value) => {
    if (isNaN(value)) {
      return "0";
    }
    const num = parseFloat(value);
    return num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const handleCreateHandover = async () => {
    const handoverResult = await fuziElevatorsApi.createHandoverRecord({
      owner_id: order.owner_id,
      handover_date: order.handover_date,
      orderid: order.id,
      offer_id: order.offer_id,
    });
    handoverResult?.success
      ? PubSub.publish("RECORD_SAVED_TOAST", {
        title: "Handover record created",
        message: "Record created successfully",
      })
      : PubSub.publish("RECORD_ERROR_TOAST", {
        title: "Error while creating handover record",
        message: handoverResult?.errors,
      });
  };
  
  //warranty create then create warranty button hide Updated by Imran Khan on 18 feb 2026
  const handleCreateWarranty = async () => {
    if (creatingWarranty) return;
    if (order.order_status !== "Order Work Complete") return;

    setCreatingWarranty(true);

    const warrantyCheck = await fuziElevatorsApi.checkWarrantyExists(order.id);

    if (warrantyCheck?.exists) {
      PubSub.publish("RECORD_ERROR_TOAST", {
        title: "Warranty Already Exists",
        message: "A warranty record already exists for this order.",
      });
      setCreatingWarranty(false);
      return;
    }

    const warrantyResult = await fuziElevatorsApi.createWarranty({
      warranty_status: "Warranty Running",
      owner_ids: (order.owner_ids || []).map((o) => o.value),
      warranty_start_date: order.handover_date
        ? formatDate(order.handover_date)
        : null,
      warranty_end_date: order.warranty_end_date
        ? formatDate(order.warranty_end_date)
        : null,
      order_id: order.id,
    });
    //Imran Khan AMC Ticket 1062- added this condition to check if warranty is running or not
    if (warrantyResult?.success) {
      const orderUpdateResult = await fuziElevatorsApi.saveOrder({
        id: order.id,
        order_status: "Warranty Running",
      });

      if (orderUpdateResult?.success) {
        setOrder((prev) => ({ ...prev, order_status: "Warranty Running" }));
      }
      setWarrantyExists(true);
      PubSub.publish("RECORD_SAVED_TOAST", {
        title: "Warranty record created",
        message: "Record created successfully",
      });
    } else {
      PubSub.publish("RECORD_ERROR_TOAST", {
        title: "Error while creating warranty record",
        message: warrantyResult?.errors,
      });
    }

    setCreatingWarranty(false);
  };
  //End Here

  return (
    <Container className="pb-5">
      {order && (
        <>
          {modalShow && (
            <Confirm
              show={modalShow}
              onHide={() => setModalShow(false)}
              deleteOrder={deleteOrder}
              title="Confirm delete?"
              message="You are going to delete the record. Are you sure?"
              table="order"
            />
          )}

          <Row className="view-form   mx-auto">
            <Col md={12} className="">
              <Breadcrumb>
                <Breadcrumb.Item onClick={() => navigate(ROUTES.HOME)}>
                  Home
                </Breadcrumb.Item>
                <Breadcrumb.Item onClick={() => navigate(ROUTES.ORDER.LIST)}>
                  Orders
                </Breadcrumb.Item>
              </Breadcrumb>
            </Col>

            <Col lg={12} className="">
              <Container className="pb-3 sticky-card-header-view">
                <Row className="view-form-header-lead bg-custom align-items-center rounded  ">
                  <Col lg={6}>
                    <h6 className="m-0 ">Order</h6>
                    <h4 className="m-0 ">{order.offer_name_label || ""}</h4>
                  </Col>

                  {/* Imran Khan Updated Create Warranty validation on Status Order Work Completed 6-1-2026 */}
                  <Col lg={6} className="d-flex justify-content-end gap-3">
                    {/* {[
                      PERMISSIONS.MODIFY_ALL,
                      PERMISSIONS?.MODIFY_WARRANTY,
                    ].some((permission) => {
                      console.log(
                        order.order_status == "Order Work Complete",
                        order.order_status,
                      );
                      return userInfo?.permissions
                        ?.map((p) => p.name)
                        .includes(permission);
                    }) &&
                      

                      order?.order_status === "Order Work Complete" &&
                      order.warranty_end_date && (
                        <Button
                          className="btn-save"
                          //disabled={order?.order_status !== "Order Work Complete"}
                          onClick={handleCreateWarranty}
                        >
                          Create Warranty
                        </Button>
                      )} */}

                      {[PERMISSIONS.MODIFY_ALL, PERMISSIONS?.MODIFY_WARRANTY].some(
                        (permission) => {
                          return userInfo?.permissions
                            ?.map((p) => p.name)
                            .includes(permission);
                        }
                      ) &&
                        order?.order_status === "Order Work Complete" &&
                        order.warranty_end_date &&
                        !warrantyExists && (
                          <Button
                            className="btn-save"
                            onClick={handleCreateWarranty}
                          >
                            Create Warranty
                          </Button>
                        )}
                    {/*End here */}

                    {[PERMISSIONS.MODIFY_ALL, PERMISSIONS?.MODIFY_ORDER].some(
                      (permission) => {
                        return userInfo?.permissions
                          ?.map((p) => p.name)
                          .includes(permission);
                      },
                    ) && (
                        <Button
                          size="sm"
                          className="btn-edit"
                          onClick={() => edit(true)}
                        >
                          <i className="fa-regular fa-pen-to-square"></i>
                        </Button>
                      )}

                    {[PERMISSIONS.DELETE_ALL, PERMISSIONS?.DELETE_ORDER].some(
                      (permission) => {
                        return userInfo?.permissions
                          ?.map((p) => p.name)
                          .includes(permission);
                      },
                    ) && (
                        <Button
                          size="sm"
                          className="btn-delete"
                          onClick={() => setModalShow(true)}
                        >
                          <i className="fa fa-trash-o"></i>
                        </Button>
                      )}
                  </Col>
                </Row>
              </Container>
              <Card>
                <CardHeader className="sticky-tabs-header">
                  <Col lg={12} className="mt-4" style={{ color: "#fff" }}>
                    <Tabs
                      defaultActiveKey="details"
                      id="uncontrolled-tab-example"
                      onSelect={(key) => handleTab(key)}
                      style={{ marginBottom: "12px" }}
                    >
                      <Tab eventKey="details" title="Details"></Tab>
                      <Tab
                        eventKey="notesMessages"
                        title="Notes & Messages"
                      ></Tab>
                    </Tabs>
                  </Col>
                </CardHeader>

                <CardBody className="card-body-scroll">
                  <Container>
                    {showDetails && (
                      <Row className="">
                        {/* Imran Khan Added Lead Status with Colors AMC Ticket 1069*/}
                        {/* Cumulative Timeline - Specific Lost Highlight */}
                        <Col lg={12} className="mb-4 mt-2">
                          <div className="scrollable-container">
                            <div className="bar">
                              {constants.ORDER_STATUS_VALUES.sort((a, b) => a.sortorder - b.sortorder).map((statusObj, index) => {
                                const currentStatusLabel = order?.order_status;
                                const currentStatusObj = constants.ORDER_STATUS_VALUES.find(s => s.label === currentStatusLabel);
                                const currentSortOrder = currentStatusObj ? currentStatusObj.sortorder : 0;
                                
                                const isThisStatusCurrent = currentStatusLabel === statusObj.label;
                                const isThisStatusLostType = statusObj.is_lost;

                                let stepClass = "bar-step";
                                // Default: White (Future steps)
                                let inlineStyle = { backgroundColor: "#bdb8b8", color: "#333", border: "1px solid #ccc" };

                                // 1. LOST RED LOGIC
                                if (isThisStatusCurrent && isThisStatusLostType) {
                                  inlineStyle = { backgroundColor: "#dc3545", color: "white", border: "1px solid #dc3545" };
                                }
                                // 2. CURRENT ACTIVE STATUS (Sirf yahi Green dikhega)
                                else if (isThisStatusCurrent) {
                                  stepClass = "bar-step completed"; 
                                  inlineStyle = { backgroundColor: "#28a745", color: "white", border: "1px solid #28a745" };
                                }
                                // 3. PICHLE SARE STEPS (Sabhi Dark Grey honge, koi extra Green nahi)
                                else if (!isThisStatusLostType && statusObj.sortorder < currentSortOrder) {
                                  stepClass = "bar-step completed";
                                  inlineStyle = { backgroundColor: "#343a40", color: "white", border: "1px solid #343a40" };
                                }
                                
                                return (
                                  <div key={index} className={stepClass} style={inlineStyle}>
                                    {statusObj.label}
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        </Col>
                        {/* <Col lg={12}>
                            <div className="scrollable-container">
                                <Path
                                    values={highlightedStatusArray}
                                    selectedValue={order.offer_status}
                                />
                            </div>
                        </Col> */}
                        {/* formatDateForView added by shahir hussain 27-08-2025 */}
                        <>
                          {/* Added by Imran Khan 27 April 2026 Identity Tabs Legend */}
                          <Col lg={12} className="mb-4 d-flex justify-content-center gap-4 flex-wrap" style={{ borderBottom: "1px solid #eee", paddingBottom: "15px" }}>
                            <div className="d-flex align-items-center gap-2">
                              <div style={{ width: '12px', height: '12px', backgroundColor: '#28a745', borderRadius: '2px' }}></div>
                              <small className="fw-bold text-secondary">Current Status (Active)</small>
                            </div>
                            <div className="d-flex align-items-center gap-2">
                              <div style={{ width: '12px', height: '12px', backgroundColor: '#dc3545', borderRadius: '2px' }}></div>
                              <small className="fw-bold text-secondary">Lost / Cancelled</small>
                            </div>
                            <div className="d-flex align-items-center gap-2">
                              <div style={{ width: '12px', height: '12px', backgroundColor: '#343a40', borderRadius: '2px' }}></div>
                              <small className="fw-bold text-secondary">Completed Steps</small>
                            </div>
                            <div className="d-flex align-items-center gap-2">
                              <div style={{ width: '12px', height: '12px', backgroundColor: '#bdb8b8', borderRadius: '2px', border: '1px solid #ccc' }}></div>
                              <small className="fw-bold text-secondary">Upcoming Steps</small>
                            </div>
                          </Col>
                          <Col lg={6}>
                            <label>Job Number</label>
                            <span>{order.job_no || ""}</span>
                          </Col>
                          <Col lg={6}>
                            <label>order Date</label>
                            <span>{formatDateForView(order.order_date)}</span>
                          </Col>
                          <Col lg={6}>
                            <label>Offer</label>
                            <span>{order.offer_name_label || ""}</span>
                          </Col>
                          <Col lg={6}>
                            <label>Lead</label>
                            <span>{order.lead_name || ""}</span>
                          </Col>
                          <Col lg={6}>
                            <label>Status</label>
                            <span>{order.order_status || ""}</span>
                          </Col>
                          <Col lg={6}>
                            <label>Email</label>
                            <span>{order.email || ""}</span>
                          </Col>
                          <Col lg={6}>
                            <label>Phone</label>
                            <span>{order.phone || ""}</span>
                          </Col>
                          <Col lg={6}>
                            <label>WhatsApp Number</label>
                            <span>{order.whatsapp_no || ""}</span>
                          </Col>
                          <Col lg={6}>
                            <label>Assigned Users</label>
                            <span>
                              <div className="d-flex flex-wrap gap-1">
                                {order?.owner_ids?.map((item) => (
                                  <Badge bg="warning">
                                    <Link
                                      to={`${ROUTES.USER.LIST}/${item.value}`}
                                      className="text-decoration-none text-dark fw-bold"
                                    >
                                      {item.label}
                                    </Link>
                                  </Badge>
                                ))}
                              </div>
                            </span>
                          </Col>
                          {/* <Col lg={6}>
                            <label>Assigned User</label>
                            <span> 
                              <img
                                src="https://www.w3schools.com/bootstrap4/img_avatar3.png"
                                className="rounded-circle"
                                style={{
                                  height: "30px",
                                  width: "30px",
                                  objectFit: "cover",
                                }}
                                alt=""
                              />
                              <img
                                src={localStorage.getItem("myimage")}
                                className="rounded-circle"
                                style={{ height: "30px" }}
                                alt=""
                              />
                              <Badge
                                bg="warning"
                                className="mx-2"
                                style={{ display: "inline", color: "#000" }}
                              >
                                {order?.owner_name || ""}
                              </Badge>
                            </span>
                          </Col> */}
                          {/* <Col lg={6}>
                                  <label>Offer Status</label>
                                  <span>{order.offer_status}</span>
                              </Col> */}

                          {/* {order?.offer_status === 'Lost' &&
                              <Col lg={6}>
                                  <label>Offer Remark</label>
                                  <span>{order.offer_remark}</span>
                              </Col>} */}
                          <Col lg={6}>
                            <label>Created Date</label>
                            <span>
                              {formatDateForView(order?.createddate || "")}
                            </span>
                          </Col>
                        </>
                        <>
                          <Col md={12} className="section-header">
                            Customer Information
                          </Col>
                          <Col lg={6}>
                            <label>Customer Type</label>
                            <span>{order.customer_type || ""}</span>
                          </Col>
                          <Col lg={6}>
                            <label>Company Name</label>
                            <span>{order.company_name || ""}</span>
                          </Col>
                          <Col lg={6}>
                            <label>Sector</label>
                            <span>{order.sector || ""}</span>
                          </Col>
                          {/* {order.is_gst === "Yes" && (
                            <Col lg={6}>
                              <label>GST Number</label>
                              <span>{order.gst_no}</span>
                            </Col>
                          )} */}

                          {/*Added by Imran Khan 09-01-2026 */}
                          <Col lg={6}>
                            <label>Is GST Applicable</label>
                            <span>{order?.is_gst || ""}</span>
                          </Col>

                          {order?.is_gst === "Yes" && order?.gst_no && (
                            <Col lg={6}>
                              <label>GST Number</label>
                              <span>{order.gst_no}</span>
                            </Col>
                          )}
                          {/*End Here */}

                          <Col lg={6}>
                            <label>Competitor Name</label>
                            <span>{order.competitor_name || ""}</span>
                          </Col>
                          {/* Add Segment Type by shahir hussain 02-02-2026 */}
                          <Col lg={6}>
                            <label>Segment Type</label>
                            <span>{order?.segment || ""}</span>
                          </Col>
                        </>

                        <>
                          <Col md={12} className="section-header">
                            Order Information
                          </Col>
                          {[
                            PERMISSIONS.VIEW_ALL,
                            PERMISSIONS?.VIEW_PAYMENT,
                          ].some((permission) => {
                            return userInfo?.permissions
                              ?.map((p) => p.name)
                              .includes(permission);
                          }) && (
                              <>
                                <Col lg={6}>
                                  <label>Order Value</label>
                                  <span>{order.order_amount || ""}</span>
                                </Col>
                                <Col lg={6}>
                                  <label>Quantity</label>
                                  <span>{order.qty || ""}</span>
                                </Col>

                                {/* commented by shahir hussain 13-06-2025 */}
                                {/* <Col lg={6}>
                            <label>Basic Amount Value</label>
                            <span>{order.basic_amount || ""}</span>
                          </Col> */}
                                <Col lg={6}>
                                  <label>Cheque Amount</label>
                                  <span>{order.cheque_amount || ""}</span>
                                </Col>
                                <Col lg={6}>
                                  <label>Cash Amount</label>
                                  <span>{order.cash_amount || ""}</span>
                                </Col>
                                <Col lg={6}>
                                  <label>TPC Amount</label>
                                  <span>{order.tpc_amount || ""}</span>
                                </Col>
                              </>
                            )}
                          <Col lg={6}>
                            <label>Building Location</label>
                            <span>{order.building_location || ""}</span>
                          </Col>
                          <Col lg={6}>
                            <label>Warranty Period</label>
                            <span>{order.warranty_upto || ""}</span>
                          </Col>
                          <Col lg={6}>
                            <label>Handover Date</label>
                            <span>
                              {order?.handover_date
                                ? formatDateForView(order.handover_date)
                                : ""}
                            </span>
                          </Col>
                          {/* <Col lg={6}>
                            <label>Warranty Start Date</label>
                            <span>
                              {order?.warranty_start_date
                                ? formatDate(order.warranty_start_date)
                                : ""}
                            </span>
                          </Col> */}
                          <Col lg={6}>
                            <label>Warranty Upto</label>
                            <span>
                              {order?.warranty_end_date
                                ? formatDateForView(order.warranty_end_date)
                                : ""}
                            </span>
                          </Col>
                        </>

                        <>
                          <Col lg={12} className="section-header">
                            GAD INFORMATION
                          </Col>
                          <Col lg={6}>
                            <label>GAD Status</label>
                            <span>{order?.gad_status || ""}</span>
                          </Col>
                          <Col lg={6}>
                            <label>GAD Allowed To</label>
                            <span>
                              {order?.gad_allowed_to
                                ? formatDateForView(order.gad_allowed_to)
                                : ""}
                            </span>
                          </Col>
                          <Col lg={6}>
                            <label>GAD Finalized On</label>
                            <span>
                              {order?.gad_finalized_on
                                ? formatDateForView(order.gad_finalized_on)
                                : ""}
                            </span>
                          </Col>
                        </>

                        <>
                          <Col lg={12} className="section-header">
                            Material Allotment INFORMATION
                          </Col>
                          <Col lg={6}>
                            <label>Scaffolding Material Status</label>
                            <span>
                              {order?.scaffolding_material_status || ""}
                            </span>
                          </Col>
                          <Col lg={6}>
                            <label>Scaffolding Material Status Date</label>
                            <span>
                              {order?.scaffolding_material_status_date
                                ? formatDateForView(
                                  order.scaffolding_material_status_date,
                                )
                                : ""}
                            </span>
                          </Col>
                          <Col lg={6}>
                            <label>Customer White Wash Status</label>
                            <span>
                              {order?.customer_white_wash_status || ""}
                            </span>
                          </Col>
                          <Col lg={6}>
                            <label>Customer White Wash Status Date</label>
                            <span>
                              {order?.customer_white_wash_status_date
                                ? formatDateForView(
                                  order.customer_white_wash_status_date,
                                )
                                : ""}
                            </span>
                          </Col>
                          <Col lg={6}>
                            <label>Customer Shaft Lighting Status</label>
                            <span>
                              {order?.customer_shaft_lighting_status || ""}
                            </span>
                          </Col>
                          <Col lg={6}>
                            <label>Customer Shaft Lighting Status Date</label>
                            <span>
                              {order?.customer_shaft_lighting_status_date
                                ? formatDateForView(
                                  order.customer_shaft_lighting_status_date,
                                )
                                : ""}
                            </span>
                          </Col>
                          <Col lg={6}>
                            <label>Customer 3phase Earthing Status</label>
                            <span>
                              {order?.customer_3phase_earthing_status || ""}
                            </span>
                          </Col>
                          <Col lg={6}>
                            <label>Customer 3phase Earthing Status Date</label>
                            <span>
                              {order?.customer_3phase_earthing_status_date
                                ? formatDateForView(
                                  order.customer_3phase_earthing_status_date,
                                )
                                : ""}
                            </span>
                          </Col>
                          <Col lg={6}>
                            <label>Door Supplied Status</label>
                            <span>{order?.door_supplied_status || ""}</span>
                          </Col>
                          <Col lg={6}>
                            <label>Door Supplied Status Date</label>
                            <span>
                              {order?.door_supplied_status_date
                                ? formatDateForView(
                                  order.door_supplied_status_date,
                                )
                                : ""}
                            </span>
                          </Col>

                          <Col lg={6}>
                            <label>Motor Supplied Status</label>
                            <span>{order?.motor_supplied_status || ""}</span>
                          </Col>

                          <Col lg={6}>
                            <label>Motor Supplied Status Date</label>
                            <span>
                              {order?.motor_supplied_status_date
                                ? formatDateForView(
                                  order.motor_supplied_status_date,
                                )
                                : ""}
                            </span>
                          </Col>

                          <Col lg={6}>
                            <label>Cabin Status</label>
                            <span>{order?.cabin_status || ""}</span>
                          </Col>

                          <Col lg={6}>
                            <label>Cabin Status Date</label>
                            <span>
                              {order?.cabin_status_date
                                ? formatDateForView(order.cabin_status_date)
                                : ""}
                            </span>
                          </Col>

                          <Col lg={6}>
                            <label>Control Panel Status</label>
                            <span>{order?.control_panel_status || ""}</span>
                          </Col>

                          <Col lg={6}>
                            <label>Control Panel Status Date</label>
                            <span>
                              {order?.control_panel_status_date
                                ? formatDateForView(
                                  order.control_panel_status_date,
                                )
                                : ""}
                            </span>
                          </Col>

                          <Col lg={6}>
                            <label>Customer Archive Work Status</label>
                            <span>
                              {order?.customer_archive_work_status || ""}
                            </span>
                          </Col>

                          <Col lg={6}>
                            <label>Customer Archive Work Status Date</label>
                            <span>
                              {order?.customer_archive_work_status_date
                                ? formatDateForView(
                                  order.customer_archive_work_status_date,
                                )
                                : ""}
                            </span>
                          </Col>

                          <Col lg={6}>
                            <label>Material Ready Status</label>
                            <span>{order?.material_ready_status || ""}</span>
                          </Col>

                          <Col lg={6}>
                            <label>Material Ready Status Date</label>
                            <span>
                              {order?.material_ready_status_date
                                ? formatDateForView(
                                  order.material_ready_status_date,
                                )
                                : ""}
                            </span>
                          </Col>

                          <Col lg={6}>
                            <label>Admin Approval Status</label>
                            <span>{order?.admin_approval_status || ""}</span>
                          </Col>

                          <Col lg={6}>
                            <label>Admin Approval Status Date</label>
                            <span>
                              {order?.admin_approval_status_date
                                ? formatDateForView(
                                  order.admin_approval_status_date,
                                )
                                : ""}
                            </span>
                          </Col>

                          <Col lg={6}>
                            <label>Commissioning Status</label>
                            <span>{order?.commissioning_status || ""}</span>
                          </Col>

                          <Col lg={6}>
                            <label>Commissioning Status Date</label>
                            <span>
                              {order?.commissioning_status_date
                                ? formatDateForView(
                                  order.commissioning_status_date,
                                )
                                : ""}
                            </span>
                          </Col>

                          <Col lg={12} className="section-header">
                            MATERIAL INFORMATION
                          </Col>

                          <Col lg={6}>
                            <label>Passenger Capacity</label>
                            <span>{order?.passenger_capacity || ""}</span>
                          </Col>

                          <Col lg={6}>
                            <label>Total Number Of Stops</label>
                            <span>{order?.total_stops || ""}</span>
                          </Col>

                          <Col lg={6}>
                            <label>Same Side</label>
                            <span>{order?.same_side || ""}</span>
                          </Col>

                          <Col lg={6}>
                            <label>Number Of Openings</label>
                            <span>{order?.number_of_openings || ""}</span>
                          </Col>

                          <Col lg={6}>
                            <label>Floor Counts</label>
                            <span>{order?.floor_counts || ""}</span>
                          </Col>

                          <Col lg={6}>
                            <label>Motor</label>
                            <span>{order?.motor || ""}</span>
                          </Col>

                          <Col lg={6}>
                            <label>Motor Make</label>
                            <span>{order?.motor_make || ""}</span>
                          </Col>

                          <Col lg={6}>
                            <label>Controller Make</label>
                            <span>{order?.controller_make || ""}</span>
                          </Col>

                          <Col lg={6}>
                            <label>Lift Speed</label>
                            <span>{order?.lift_speed || ""}</span>
                          </Col>

                          <Col lg={6}>
                            <label>Door Opening</label>
                            <span>{order?.door_opening || ""}</span>
                          </Col>

                          <Col lg={6}>
                            <label>Door Make</label>
                            <span>{order?.door_make || ""}</span>
                          </Col>

                          <Col lg={6}>
                            <label>Door Metal</label>
                            <span>{order?.door_metal || ""}</span>
                          </Col>

                          <Col lg={6}>
                            <label>All Doors Same</label>
                            <span>{order?.all_doors_same || ""}</span>
                          </Col>

                          <Col lg={6}>
                            <label>Different Floor Name</label>
                            <span>{order?.different_floor_name || ""}</span>
                          </Col>

                          <Col lg={6}>
                            <label>Cabin Metal</label>
                            <span>{order?.cabin_metal || ""}</span>
                          </Col>

                          <Col lg={6}>
                            <label>Door Panels</label>
                            <span>{order?.door_panels || ""}</span>
                          </Col>

                          <Col lg={6}>
                            <label>Door Width</label>
                            <span>{order?.door_width || ""}</span>
                          </Col>

                          <Col lg={6}>
                            <label>Door Height</label>
                            <span>{order?.door_height || ""}</span>
                          </Col>

                          <Col lg={6}>
                            <label>Door Vision</label>
                            <span>{order?.door_vision || ""}</span>
                          </Col>

                          <Col lg={6}>
                            <label>Shaft Width</label>
                            <span>{order?.shaft_width || ""}</span>
                          </Col>

                          <Col lg={6}>
                            <label>Shaft Depth</label>
                            <span>{order?.shaft_depth || ""}</span>
                          </Col>

                          <Col lg={6}>
                            <label>Shaft Construction</label>
                            <span>{order?.shaft_construction || ""}</span>
                          </Col>

                          <Col lg={6}>
                            <label>Machine Room</label>
                            <span>{order?.machine_room || ""}</span>
                          </Col>

                          <Col lg={6}>
                            <label>Dlp Period</label>
                            <span>{order?.dlp_period || ""}</span>
                          </Col>

                          <Col lg={6}>
                            <label>Brand Offered</label>
                            <span>{order?.brand_offered || ""}</span>
                          </Col>

                          <Col lg={6}>
                            <label>Special Request</label>
                            <span>{order?.special_request || ""}</span>
                          </Col>
                        </>

                        <>
                          <Col lg={12} className="section-header">
                            ADDRESS INFORMATION
                          </Col>
                          <Col lg={6}>
                            <label>Site Address</label>
                            <span>{order.site_address || ""}</span>
                          </Col>
                          {/* Added by shahir hussain */}
                          <Col lg={6}>
                            <label>Area</label>
                            <span>{order?.area || ""}</span>
                          </Col>
                          <Col lg={6}>
                            <label>State</label>
                            <span>{order.state || ""}</span>
                          </Col>
                          <Col lg={6}>
                            <label>City</label>
                            <span>{order.city || ""}</span>
                          </Col>
                          <Col lg={6}>
                            <label>Office Address</label>
                            <span>{order.office_address || ""}</span>
                          </Col>
                          <Col lg={6}>
                            <label>Office City</label>
                            <span>{order.office_city || ""}</span>
                          </Col>
                          <Col lg={6}>
                            <label>Pincode</label>
                            <span>{order.pincode || ""}</span>
                          </Col>
                          <Col lg={6}>
                            <label>Country</label>
                            <span>{order.country || ""}</span>
                          </Col>
                        </>

                        {/*Imran Khan Update Lead View page for Order Lost Lead Information*/}
                        {order.order_status === "Order Lost" && (
                          <>
                            <Col lg={12} className="section-header">
                              ORDER LOST INFORMATION
                            </Col>
                            <Col lg={6}>
                              <label>Lost Date</label>
                              <span>
                                {formatDateForCreatedDate(
                                  order?.lost_date || "",
                                )}
                              </span>
                            </Col>
                            <Col lg={6}>
                              <label>Lead Lost Remark</label>
                              <span>{order.lost_remark}</span>
                            </Col>
                            <Col lg={6}>
                              <label>Lost By (Company)</label>
                              <span>{order.lost_by_reason}</span>
                            </Col>
                          </>
                        )}
                        {/*End Imran Khan Update Lead View page for Enquiry Lost Lead Information*/}

                        {/*Imran Khan Update View page for Order Payment Information on 12/01/2026*/}
                        {/* Imran Khan Added condition for Payment Related List to hide from Installation Supervisor 24-Feb-2026 */}
                        {!isInstallationSupervisor &&
                          [PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_PAYMENT].some((permission) => {
                            return userInfo?.permissions?.map((p) => p.name).includes(permission);
                          }) && (
                          <>
                            {/* Payment Block to Track or Show Payment Order Wise */}
                            <Col lg={12} className="section-header">
                              AMOUNT INFORMATION
                            </Col>

                            <Col lg={6}>
                              <label>Order Value Without Tax</label>
                              <Badge
                                bg="info"
                                style={{
                                  width: "30%",
                                  fontWeight: "normal",
                                  fontSize: "1rem",
                                  textAlign: "left",
                                }}
                              >
                                {"₹ " + formatAmount(Number(order?.order_amount) || 0)}{" "}
                              </Badge>
                            </Col>

                            <Col lg={6}>
                              <label>Total Received Amount</label>
                              <Badge
                                bg="success"
                                style={{
                                  width: "30%",
                                  fontWeight: "normal",
                                  fontSize: "1rem",
                                  textAlign: "left",
                                }}
                              >
                                {"₹ " + formatAmount(Number(payments?.total || 0))}
                              </Badge>
                            </Col>

                            <Col lg={6}>
                              <label>Cash Amount</label>
                              <Badge
                                bg="info"
                                style={{
                                  width: "30%",
                                  fontWeight: "normal",
                                  fontSize: "1rem",
                                  textAlign: "left",
                                }}
                              >
                                {"₹ " + formatAmount(Number(order?.cash_amount) || 0)}
                              </Badge>
                            </Col>

                            <Col lg={6}>
                              <label>Received Cash Amount</label>
                              <Badge
                                bg="success"
                                style={{
                                  width: "30%",
                                  fontWeight: "normal",
                                  fontSize: "1rem",
                                  textAlign: "left",
                                }}
                              >
                                {"₹ " + formatAmount(Number(payments?.Cash) || 0)}
                              </Badge>
                            </Col>

                            <Col lg={6}>
                              <label>Cheque Amount</label>
                              <Badge
                                bg="info"
                                style={{
                                  width: "30%",
                                  fontWeight: "normal",
                                  fontSize: "1rem",
                                  textAlign: "left",
                                }}
                              >
                                {"₹ " + formatAmount(Number(order?.cheque_amount) || 0)}
                              </Badge>
                            </Col>

                            <Col lg={6}>
                              <label>Received Cheque Amount</label>
                              <Badge
                                bg="success"
                                style={{
                                  width: "30%",
                                  fontWeight: "normal",
                                  fontSize: "1rem",
                                  textAlign: "left",
                                }}
                              >
                                {"₹ " + formatAmount(Number(payments?.Cheque) || 0)}
                              </Badge>
                            </Col>

                            {/* Updated by Imran Khan 09-01-2026 */}
                            <Col lg={6}>
                              <label>Tax Amount</label>
                              <Badge
                                bg="warning"
                                style={{
                                  width: "30%",
                                  fontWeight: "normal",
                                  fontSize: "1rem",
                                  textAlign: "left",
                                }}
                              >
                                {"₹ " + formatAmount(Number(order?.tax_amount) ?? 0)}
                              </Badge>
                            </Col>

                            {/* Added Math.max by Imran Khan 09-01-2026 to avoid negative pending amount */}
                            <Col lg={6}>
                              <label>Pending Cheque Amount</label>
                              <Badge
                                bg="danger"
                                style={{
                                  width: "30%",
                                  fontSize: "1rem",
                                  textAlign: "left",
                                }}
                              >
                                {"₹ " +
                                  formatAmount(
                                    Math.max(
                                      (Number(order?.cheque_amount) || 0) +
                                        (Number(order?.tax_amount) || 0) -
                                        (Number(payments?.Cheque) || 0),
                                      0,
                                    ),
                                  )}
                              </Badge>
                            </Col>

                            <Col lg={6}>
                              <label>Total Cheque Amount</label>
                              <Badge
                                bg="dark"
                                style={{
                                  width: "30%",
                                  fontWeight: "normal",
                                  fontSize: "1rem",
                                  textAlign: "left",
                                }}
                              >
                                {"₹ " +
                                  formatAmount(
                                    (Number(order?.cheque_amount) || 0) +
                                      (Number(order?.tax_amount) || 0),
                                  )}
                              </Badge>
                            </Col>

                            <Col lg={6}>
                              <label>Pending Cash Amount</label>
                              <Badge
                                bg="danger"
                                style={{
                                  width: "30%",
                                  fontWeight: "normal",
                                  fontSize: "1rem",
                                  textAlign: "left",
                                }}
                              >
                                {"₹ " +
                                  formatAmount(
                                    Number(order.cash_amount) - (Number(payments.Cash) || 0),
                                  )}
                              </Badge>
                            </Col>

                            <Col lg={6}>
                              <label>Due Amount</label>
                              <Badge
                                bg="dark"
                                style={{
                                  width: "30%",
                                  fontWeight: "normal",
                                  fontSize: "1rem",
                                  textAlign: "left",
                                }}
                              >
                                {"₹ " + formatAmount(Number(order?.due_amount || 0))}
                              </Badge>
                            </Col>

                            {/* Added by Imran Khan 09-01-2026 */}
                            <Col lg={6}>
                              <label>Total Pending Amount</label>
                              <Badge
                                bg="danger"
                                style={{
                                  width: "30%",
                                  fontWeight: "normal",
                                  fontSize: "1rem",
                                  textAlign: "left",
                                }}
                              >
                                {"₹ " +
                                  formatAmount(
                                    Number(order?.due_amount) - Number(payments?.total || 0),
                                  )}
                              </Badge>
                            </Col>
                            {/* End Here */}
                          </>
                        )}
                        <Col lg={12}>
                          <div
                            id="googleMapaddress"
                            className="my-2"
                            style={{
                              width: "100%",
                              height: "300px",
                              border: "1px solid black",
                            }}
                          ></div>
                        </Col>
                      </Row>
                    )}

                    {showNotesMessages && (
                      <Card className="mt-2">
                        <Row className="mt-4">
                          <Col lg={12}>
                            <Chat parentid={order.id} />
                          </Col>
                        </Row>
                      </Card>
                    )}
                  </Container>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Card bg="light" text="light" className="mb-2 mt-4 shadow">
            <Card.Header className="d-flex justify-content-between">
              <Tabs
                defaultActiveKey="files"
                id="uncontrolled-tab-example"
                onSelect={(key) => handleRelatedListTab(key)}
              >
                {[PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_FILE].some(
                  (permission) => {
                    return userInfo?.permissions
                      ?.map((p) => p.name)
                      .includes(permission);
                  },
                ) && <Tab eventKey="files" title="Files"></Tab>}
                {[PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_TASK].some(
                  (permission) => {
                    return userInfo?.permissions
                      ?.map((p) => p.name)
                      .includes(permission);
                  },
                ) && <Tab eventKey="tasks" title="Tasks"></Tab>}
                {/* {[PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_HANDOVER].some(permission => {
                  return userInfo?.permissions?.map(p => p.name).includes(permission);
                }) && (
                    <Tab eventKey="handover" title="Handover"></Tab>
                  )} */}
                {[PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_WARRANTY].some(
                  (permission) => {
                    return userInfo?.permissions
                      ?.map((p) => p.name)
                      .includes(permission);
                  },
                ) && <Tab eventKey="warranty" title="Warranty"></Tab>}
                {[PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_AMC].some(
                  (permission) => {
                    return userInfo?.permissions
                      ?.map((p) => p.name)
                      .includes(permission);
                  },
                ) && <Tab eventKey="orderAMCs" title="AMCs"></Tab>}
                  {/* Payment Tab - Installation Supervisor ko nahi dikhega */}
                {!isInstallationSupervisor &&
                  [PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_PAYMENT].some(
                    (permission) => {
                      return userInfo?.permissions
                        ?.map((p) => p.name)
                        .includes(permission);
                    },
                ) && <Tab eventKey="payment" title="Payment"></Tab>}
              </Tabs>

              {relatedListFiles &&
                [PERMISSIONS.MODIFY_ALL, PERMISSIONS?.MODIFY_FILE].some(
                  (permission) => {
                    return userInfo?.permissions
                      ?.map((p) => p.name)
                      .includes(permission);
                  },
                ) && (
                  <Button
                    size="sm"
                    className="btn-custom float-right"
                    onClick={() => setModalShowFile(true)}
                  >
                    New File
                  </Button>
                )}

              {relatedListTaskList &&
                [PERMISSIONS.MODIFY_ALL, PERMISSIONS?.MODIFY_TASK].some(
                  (permission) => {
                    return userInfo?.permissions
                      ?.map((p) => p.name)
                      .includes(permission);
                  },
                ) && (
                  <Button
                    size="sm"
                    className="btn-custom float-right"
                    onClick={() => setModalShowTask(true)}
                  >
                    New Task
                  </Button>
                )}

              {/* {relatedListHandover && (
                <Button
                  size="sm"
                  className="btn-custom float-right"
                  onClick={() => setModalShowHandover(true)}
                >
                  New Handover
                </Button>
              )} */}

                {!isInstallationSupervisor &&
                  relatedListPayment &&
                  [PERMISSIONS.MODIFY_ALL, PERMISSIONS?.MODIFY_PAYMENT].some(
                    (permission) => {
                      return userInfo?.permissions
                        ?.map((p) => p.name)
                        .includes(permission);
                    },
                  ) && (
                  <Button
                    size="sm"
                    className="btn-custom float-right"
                    onClick={() => setModalShowPayment(true)}
                  >
                    New Payment
                  </Button>
                )}

              {/* Modals */}
              {modalShowFile && (
                <FilesCreate
                  show={modalShowFile}
                  onHide={() => setModalShowFile(false)}
                  parent={order}
                  table="medicaltest"
                  submitFiles={submitFiles}
                />
              )}

              {modalShowTask && (
                <TaskEdit
                  show={modalShowTask}
                  onHide={() => setModalShowTask(false)}
                  parentid={order?.id}
                  table="order"
                  submitTasks={submitTasks}
                />
              )}

              {modalShowHandover && (
                <HandoverEdit
                  show={modalShowHandover}
                  onHide={() => setModalShowHandover(false)}
                  parentid={order?.id}
                  table="order"
                  submitHandover={submitHandover}
                />
              )}
              {modalShowPayment && (
                <PaymentEdit
                  show={modalShowPayment}
                  onHide={() => setModalShowPayment(false)}
                  parent={order}
                  table="paymentTablel"
                  submitpayments={submitpayments}
                  pendingAmount={order.order_amount - (payments.total || 0)}
                // pendingAmount=  {(lead.order_amount - (payments.total || 0)) }
                />
              )}
            </Card.Header>
            <Card.Body>
              {relatedListFiles &&
                [PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_FILE].some(
                  (permission) => {
                    return userInfo?.permissions
                      ?.map((p) => p.name)
                      .includes(permission);
                  },
                ) && (
                  <RelatedListFiles
                    refreshFileList={refreshFileList}
                    // onFileUpdate={updateCounter}
                    parent={order}
                    submitFiles={submitFiles}
                  />
                )}

              {relatedListTaskList &&
                [PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_TASK].some(
                  (permission) => {
                    return userInfo?.permissions
                      ?.map((p) => p.name)
                      .includes(permission);
                  },
                ) && (
                  <RelatedListTask
                    refreshTaskList={refreshTaskList}
                    parent={order}
                    submitFiles={submitTasks}
                    table="Order"
                  />
                )}

              {relatedListHandover && (
                <RelatedListHandover
                  refreshHandoverList={refreshHandoverList}
                  parentid={order?.id}
                  order={order}
                  submitHandover={submitHandover}
                />
              )}

              {relatedListWarranty &&
                [PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_WARRANTY].some(
                  (permission) => {
                    return userInfo?.permissions
                      ?.map((p) => p.name)
                      .includes(permission);
                  },
                ) && (
                  <RelatedListWarranty
                    refreshWarrantyList={refreshWarrantyList}
                    order={order}
                    table="order"
                  />
                )}

              {relatedListOrderAmc &&
                [PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_AMC].some(
                  (permission) => {
                    return userInfo?.permissions
                      ?.map((p) => p.name)
                      .includes(permission);
                  },
                ) && (
                  <RelatedListOrderAmc
                    refreshOrderAmcList={refreshOrderAmcList}
                    parentid={order?.id}
                    order={order}
                  />
                )}

                {!isInstallationSupervisor &&
                  relatedListPayment &&
                  [PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_PAYMENT].some(
                    (permission) => {
                      return userInfo?.permissions
                        ?.map((p) => p.name)
                        .includes(permission);
                    },
                  ) && (
                  <PaymentRelatedList
                    refreshPaymentList={refreshPaymentList}
                    parent={order}
                    onPaymentListUpdate={onPaymentListUpdate}
                    parentsubmitpayments={submitpayments}
                    pendingAmount={order.order_amount - (payments.total || 0)}
                  />
                )}
            </Card.Body>
          </Card>
        </>
      )}
    </Container>
  );
};
export default OrderView;
